import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import DepartamentosService from "../services/DepartamentosService";
import HorariosEntregaService from "../services/HorariosEntregaService";
import HorariosAtencionService from "../services/HorariosAtencionService";
import PreciosSucursalService from "../services/PreciosSucursalService";
import SucursalesService from "../services/SucursalesService";
import ListasPreciosService from "../services/ListasPreciosService";
import TelefonosService from "../services/TelefonosService";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import RemoveIcon from "@mui/icons-material/Remove";
import { tieneMasDe10Digitos } from "../utils/telefonoUtils";
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  Tabs,
  Tab,
  IconButton,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Autocomplete,
} from "@mui/material";
import Swal from "sweetalert2";
import { mostrarToast } from "../utils/toastUtils";
import { useNavigate, useParams } from "react-router-dom";
import EmpleadosService from "../services/EmpleadosService";
const TabPanel = ({ children, value, index }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
  >
    {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
  </div>
);
const EditarSucursal = (id) => {
  useEffect(() => {
    async function init() {
      document.title = "Editar sucursal";
      try {
        // Cargar empleados primero para poder resolver el responsable por id
        const empleadosRes = await EmpleadosService.getEmpleadosResponsable();
        const empleadosData = empleadosRes.data?.empleados || [];
        setEmpleados(empleadosData);

        // Cargar sucursal pasando la lista de empleados para resolver el responsable
        await getSucursal(empleadosData);

        // Cargar el resto de recursos (no requieren orden estricto)
        getTelefonos();
        getSucursalesActivos();
        getHorariosEntrega();
        getHorariosAtencion();
        getListasPreciosSucursal();
        fetchListasPrecios();
      } catch (error) {
        console.error("Error inicializando EditarSucursal:", error);
      }
    }

    init();
  }, []);
  const routeParams = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  function mostrarMensaje(mensaje) {
    mostrarToast(mensaje, "success");
    setTimeout(() => {
      navigate("/sucursales", { state: { fromApp: true } });
    }, 1200);
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  const generarHoras = () => {
    const horas = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hora = String(h).padStart(2, "0");
        const minuto = String(m).padStart(2, "0");
        horas.push(`${hora}:${minuto}`);
      }
    }
    horas.push("24:00");
    return horas;
  };

  const horasDelDia = generarHoras();

  function handleBuscarSucursal() {
    navigate("/sucursales", { state: { fromApp: true } });
  }

  function reloadPage() {
    window.location.reload();
  }

  const [nombreLaboratorio, setNombreLaboratorio] = useState("");
  const [leyenda, setLeyenda] = useState("");
  const [nombre, setNombre] = useState("");
  const [nombreOriginal, setNombreOriginal] = useState("");
  const [abreviatura, setAbreviatura] = useState("");
  const [abreviaturaOriginal, setAbreviaturaOriginal] = useState("");
  const [calle, setCalle] = useState("");
  const [noExterior, setNoExterior] = useState("");
  const [noInterior, setNoInterior] = useState("");
  const [cPostal, setCPostal] = useState("");
  const [colonia, setColonia] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [estado, setEstado] = useState("");
  const [responsable, setResponsable] = useState("");
  const [selectedEmpleado, setSelectedEmpleado] = useState(null);
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorNombreLaboratorio, setErrorNombreLaboratorio] = useState(false);
  const [errorAbreviatura, setErrorAbreviatura] = useState(false);
  const [errorCiudad, setErrorCiudad] = useState(false);
  const [errorTelefonos, setErrorTelefonos] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [selectedIdResponsable, setSelectedIdResponsable] = useState("");
  const [viewOnly, setViewOnly] = useState(false);
  const [telefonos, setTelefonos] = useState([""]);

  const editarSucursal = async () => {
    if (
      nombreLaboratorio === "" &&
      nombre === "" &&
      abreviatura === "" &&
      ciudad === "" &&
      telefonos.length === 0
    ) {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombreLaboratorio(true);
      setErrorNombre(true);
      setErrorAbreviatura(true);
      setErrorCiudad(true);
      setErrorTelefonos(true);
    } else if (nombreLaboratorio === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombreLaboratorio(true);
    } else if (nombre === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
    } else if (abreviatura === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorAbreviatura(true);
    } else if (ciudad === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorCiudad(true);
    } else if (telefonos[0].telefono === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorTelefonos(true);
    } else if (telefonos.some((t) => tieneMasDe10Digitos(t.telefono))) {
      mostrarError("Los números de teléfono no pueden tener más de 10 dígitos.");
    } else {

      let banderaNombre;
      if (nombreOriginal === nombre) {
        banderaNombre = false;
      } else {
        const resultado = await SucursalesService.validarSucursal(
          nombre,
          abreviatura,
        );

        if (resultado.existe === true) {
          mostrarError(resultado.mensaje);
          banderaNombre = true;
        } else {
          banderaNombre = false;
        }
      }
      if (!banderaNombre) {
        let sucursal = {
          sucursal: {
            idSucursalN: parseInt(routeParams.id),
            nombreLaboratorioN: nombreLaboratorio,
            leyendaN: leyenda,
            nombreN: nombre,
            abreviaturaN: abreviatura,
            calleN: calle,
            numExteriorN: noExterior,
            numInteriorN: noInterior,
            cPostalN: cPostal,
            coloniaN: colonia,
            ciudadN: ciudad,
            estadoN: estado,
            idResponsableN: responsable,
          },
          horariosEntregaN: horariosEntrega,
          horariosAtencionN: horariosAtencion,
          listasPrecioSucursalN: listasPrecioSucursal,
          telefonosN: telefonos,
          sucursalesActivosN: sucursalesActivos,
        };
        try {
          const resultado = await SucursalesService.updateSucursal(sucursal);
          if (resultado.data.estatus === "OK") {
            mostrarMensaje("Sucursal actualizada con éxito!");
          } else {
            mostrarError(
              "No se pudo actualizar el sucursal: " + resultado.data.mensaje,
            );
          }
        } catch (error) {
          mostrarError("Error al actualizar sucursal:", error);
        }
      }
    }
  };

  const [sucursalesActivos, setSucursalesActivos] = useState([]);
  const [listasPrecios, setListasPrecios] = useState([]);
  const [horariosEntrega, setHorariosEntrega] = useState([]);
  const [horariosAtencion, setHorariosAtencion] = useState([]);
  const [listasPrecioSucursal, setListasPrecioSucursal] = useState([]);
  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  const handleAddTelefono = () => {
    setTelefonos([...telefonos, { telefono: "" }]);
  };

  const handleChangeTelefono = (index, field, value) => {
    const nuevosTelefonos = [...telefonos];
    nuevosTelefonos[index] = {
      ...nuevosTelefonos[index],
      [field]: value,
    };
    setTelefonos(nuevosTelefonos);
  };
  const handleRemoveTelefono = (index) => {
    const nuevosTelefonos = telefonos.filter((_, i) => i !== index);
    setTelefonos(nuevosTelefonos);
  };

  const handleAddDepartamento = () => {
    setSucursalesActivos([
      ...sucursalesActivos,
      {
        nombre: "",
        codigo: "",
      },
    ]);
  };

  const handleChangeDepartamento = (index, field, value) => {
    const nuevosDepartamentos = [...sucursalesActivos];
    nuevosDepartamentos[index] = {
      ...nuevosDepartamentos[index],
      [field]: value,
    };
    setSucursalesActivos(nuevosDepartamentos);
  };

  const handleRemoveDepartamento = (index) => {
    setSucursalesActivos(sucursalesActivos.filter((_, i) => i !== index));
  };

  const handleAddEntrega = () => {
    setHorariosEntrega([
      ...horariosEntrega,
      {
        concepto: "",
        dias: "seleccione",
        horaInicio: "seleccione",
        horaFin: "seleccione",
      },
    ]);
  };

  const handleChangeEntrega = (index, field, value) => {
    const nuevosHorarios = [...horariosEntrega];
    nuevosHorarios[index] = {
      ...nuevosHorarios[index],
      [field]: value,
    };
    setHorariosEntrega(nuevosHorarios);
  };

  const handleRemoveEntrega = (index) => {
    setHorariosEntrega(horariosEntrega.filter((_, i) => i !== index));
  };

  const handleAddAtencion = () => {
    setHorariosAtencion([
      ...horariosAtencion,
      {
        concepto: "",
        dias: "",
        horario: "",
      },
    ]);
  };

  const handleChangeAtencion = (index, field, value) => {
    const nuevosHorarios = [...horariosAtencion];
    nuevosHorarios[index] = {
      ...nuevosHorarios[index],
      [field]: value,
    };
    setHorariosAtencion(nuevosHorarios);
  };

  const handleRemoveAtencion = (index) => {
    setHorariosAtencion(horariosAtencion.filter((_, i) => i !== index));
  };

  const handleAddListaPrecio = () => {
    setListasPrecioSucursal([
      ...listasPrecioSucursal,
      {
        idListaPrecio: "seleccione",
        dias: "seleccione",
        horaInicio: "seleccione",
        horaFin: "seleccione",
      },
    ]);
  };

  const handleChangeListaPrecio = (index, field, value) => {
    const nuevasListas = [...listasPrecioSucursal];
    nuevasListas[index] = {
      ...nuevasListas[index],
      [field]: value,
    };
    setListasPrecioSucursal(nuevasListas);
  };

  const handleRemoveListaPrecio = (index) => {
    setListasPrecioSucursal(listasPrecioSucursal.filter((_, i) => i !== index));
  };

  async function getTelefonos() {
    const resultado = await TelefonosService.getTelefonosPorSucursal(
      routeParams.id,
    );
    setTelefonos(resultado.telefonos);
  }

  async function getSucursalesActivos() {
    const resultado = await DepartamentosService.getDepartamentosPorSucursal(
      routeParams.id,
    );
    setSucursalesActivos(resultado.departamentos);
  }

  async function getHorariosEntrega() {
    const resultado =
      await HorariosEntregaService.getHorariosEntregaPorSucursal(
        routeParams.id,
      );
    setHorariosEntrega(resultado.horarios);
  }

  async function getHorariosAtencion() {
    const resultado =
      await HorariosAtencionService.getHorariosAtencionPorSucursal(
        routeParams.id,
      );
    setHorariosAtencion(resultado.horarios);
  }

  async function getListasPreciosSucursal() {
    const resultado =
      await PreciosSucursalService.getPreciosSucursalPorSucursal(
        routeParams.id,
      );
    setListasPrecioSucursal(resultado.precios);
  }


  async function getSucursal(empleadosData) {
    const resultado = await SucursalesService.getSucursalIndividual(
      routeParams.id,
    );

    setNombreLaboratorio(resultado.nombreLaboratorio);
    setLeyenda(resultado.leyenda);
    setNombre(resultado.nombre);
    setNombreOriginal(resultado.nombre);
    setAbreviatura(resultado.abreviatura);
    setAbreviaturaOriginal(resultado.abreviatura);
    setCalle(resultado.calle);
    setNoExterior(resultado.numExterior);
    setNoInterior(resultado.numInterior);
    setCPostal(resultado.cPostal);
    setColonia(resultado.colonia);
    setCiudad(resultado.ciudad);
    setEstado(resultado.estado);
    setResponsable(resultado.idResponsable);

    // Resolver el empleado responsable usando la lista proporcionada o el estado `empleados`
    let listToSearch =
      Array.isArray(empleadosData) && empleadosData.length > 0
        ? empleadosData
        : empleados;

    if (
      (!listToSearch || listToSearch.length === 0) &&
      !Array.isArray(empleadosData)
    ) {
      // Si no tenemos empleados en memoria, intentar cargarlos aquí (fallback)
      try {
        const res = await EmpleadosService.getEmpleadosResponsable();
        listToSearch = res.data?.empleados || [];
        setEmpleados(listToSearch);
      } catch (err) {
        console.error("Error cargando empleados en getSucursal:", err);
      }
    }

    if (listToSearch && listToSearch.length > 0 && resultado.idResponsable) {
      const emp = listToSearch.find(
        (e) =>
          e.idEmpleado === resultado.idResponsable ||
          e.idEmpleado === resultado.idResponsable,
      );
      if (emp) setSelectedEmpleado(emp);
    }
  }

  async function fetchListasPrecios() {
    try {
      const resultado = await ListasPreciosService.getListas();
      const data = resultado.data?.listas || resultado.data || [];
      setListasPrecios(data);
    } catch (error) {
      console.error("Error cargando listas de precios:", error);
    }
  }

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Box sx={{ width: "95vw", maxWidth: "96vw", mb: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label="tabs doctor"
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab
                  label="Configuracion General"
                  id="tab-0"
                  aria-controls="tabpanel-0"
                  sx={{
                    color: "black",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                    marginRight: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#d9eaf7",
                      color: "#006787",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#006787",
                      color: "white",
                    },
                  }}
                />

              </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0}>
              <Stack spacing={2} sx={{ width: "100%" }}>
                <Paper
                  elevation={3}
                  sx={{ p: 2, borderRadius: 4 }}
                  className="paperDoc"
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 0.5vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      fontWeight: "bold"
                    }}
                  >
                    DATOS DE LA SUCURSAL
                  </Typography>

                  {/* Contenedor principal */}
                  <Grid container spacing={"0.3vw"}>
                    {/* Nombre y apellidos */}
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfNombreLaboratorio"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Nombre del laboratorio:
                            <span style={{ color: "red" }}>*</span>
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={nombreLaboratorio}
                            disabled={viewOnly}
                            onChange={(e) =>
                              setNombreLaboratorio(e.target.value)
                            }
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "35vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfNombreLaboratorio"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfLeyenda"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Leyenda:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={leyenda}
                            disabled={viewOnly}
                            onChange={(e) => {
                              setLeyenda(e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "35vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfLeyenda"
                            required
                          />
                        </Grid>
                      </Stack>
                      {/* Sexo y estado civil */}

                      <Grid
                        item
                        xs={12}
                        container
                        spacing={"1vw"}
                        sx={{ paddingTop: "0.4vw" }}
                      >
                        <Stack direction="row" spacing={"3vw"}>
                          <Grid item xs={2}>
                            <InputLabel
                              htmlFor="txfNombre"
                              sx={{
                                color: "black",
                                fontSize: "1vw",
                                fontWeight: "bold",
                              }}
                            >
                              Nombre de la Toma:
                              <span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <TextField
                              fullWidth
                              value={nombre}
                              disabled={viewOnly}
                              onChange={(e) => {
                                setNombre(e.target.value);
                              }}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "35vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfNombre"
                              required
                            />
                          </Grid>

                          {/* Fecha de nacimiento */}
                          <Grid item xs={2}>
                            <InputLabel
                              htmlFor="txfAbreviatura"
                              sx={{
                                color: "black",
                                fontSize: "1vw",
                                fontWeight: "bold",
                              }}
                            >
                              Abreviatura:
                              <span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <TextField
                              fullWidth
                              value={abreviatura}
                              disabled={viewOnly}
                              onChange={(e) => setAbreviatura(e.target.value)}
                              sx={{
                                "& .MuiInputBase-root": {
                                  width: "16vw",
                                  height: "5vh",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfAbreviatura"
                            />
                          </Grid>
                          {/* Email y teléfonos */}
                        </Stack>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfCalle"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Calle:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={calle}
                            disabled={viewOnly}
                            onChange={(e) => {
                              setCalle(e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "16vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfCalle"
                            required
                          />
                        </Grid>

                        {/* Fecha de nacimiento */}
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfNoExterior"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            No. Exterior:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={noExterior}
                            onChange={(e) => setNoExterior(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "6.5vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfNoExterior"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfNoInterior"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            No. Interior:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={noInterior}
                            onChange={(e) => setNoInterior(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "6.5vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfNoInterior"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfCPostal"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Codigo Postal:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={cPostal}
                            onChange={(e) => setCPostal(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "16vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfCPostal"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfColonia"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Colonia:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={colonia}
                            onChange={(e) => setColonia(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "16vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfColonia"
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfCiudad"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Ciudad:<span style={{ color: "red" }}>*</span>
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={ciudad}
                            disabled={viewOnly}
                            onChange={(e) => {
                              setCiudad(e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                                width: "16vw",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfCiudad"
                            required
                          />
                        </Grid>

                        {/* Fecha de nacimiento */}
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfEstado"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Estado:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={estado}
                            onChange={(e) => setEstado(e.target.value)}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "16vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfEstado"
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <InputLabel
                            htmlFor="txfResponsable"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Responsable Sanitario:
                          </InputLabel>
                          <Autocomplete
                            options={empleados}
                            value={selectedEmpleado}
                            popupIcon={null}
                            getOptionLabel={(option) =>
                              option
                                ? option.nombre +
                                " " +
                                option.apPaterno +
                                " " +
                                option.apMaterno
                                : ""
                            }
                            onChange={(event, value) => {
                              setSelectedEmpleado(value);
                              setSelectedIdResponsable(
                                value ? value.idEmpleado : null,
                              );
                              setResponsable(value ? value.idEmpleado : "");
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option.idEmpleado ===
                              (value ? value.idEmpleado : null)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                disabled={viewOnly}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    width: "35vw",
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  },
                                }}
                                className="txfResponsable"
                              />
                            )}
                            filterOptions={(options, state) => {
                              const input = (state.inputValue || "")
                                .trim()
                                .toLowerCase();
                              if (!input) return options;
                              return options.filter((opt) => {
                                const combined =
                                  `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                                return combined.includes(input);
                              });
                            }}
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                  </Grid>
                </Paper>
                <Stack direction="row" spacing={"1vw"}>
                  <Paper
                    elevation={3}
                    sx={{ p: 2, borderRadius: 4 }}
                    className="paperHorario"
                  >
                    {/* Lugar de atencion */}
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0vw" }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="h7"
                          fontWeight="bold"
                          gutterBottom
                          align="center"
                          sx={{
                            background:
                              "linear-gradient(90deg, #006787, #014e65)",
                            color: "white",
                            padding: "0.5vw 1vw",
                            borderRadius: "8px",
                            display: "inline-block",
                            marginTop: "0vw",
                            fontWeight: "bold"
                          }}
                        >
                          HORARIO DE ENTREGAS
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"2vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      {horariosEntrega.map((horario, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1vw",
                            paddingTop: "0.4vw",
                            flexWrap: "wrap",
                          }}
                        >
                          <Grid item xs={6}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`txfConceptoEntrega${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                {`Concepto #${index + 1}:`}
                              </InputLabel>
                            )}
                            <TextField
                              id={`txfConceptoEntrega${index}`}
                              fullWidth
                              disabled={viewOnly}
                              value={horario.concepto}
                              onChange={(e) =>
                                handleChangeEntrega(
                                  index,
                                  "concepto",
                                  e.target.value,
                                )
                              }
                              sx={{
                                "& .MuiInputBase-root": {
                                  width: "10vw",
                                  height: "5vh",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfConceptoEntrega"
                            />
                          </Grid>

                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectDiasEntrega${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                Dia(s)
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={horario.dias}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeEntrega(
                                  index,
                                  "dias",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "8vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectDiasEntrega"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="LunesAviernes"
                              >
                                Lunes a Viernes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="SabadoDomingo"
                              >
                                Sabado y Domingo
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Lunes"
                              >
                                Lunes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Martes"
                              >
                                Martes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Miercoles"
                              >
                                Miercoles
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Jueves"
                              >
                                Jueves
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Viernes"
                              >
                                Viernes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Sabados"
                              >
                                Sabados
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Domingo"
                              >
                                Domingo
                              </MenuItem>
                            </Select>
                          </Grid>

                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectHoraInicioEntrega${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                De:
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={horario.horaInicio}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeEntrega(
                                  index,
                                  "horaInicio",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "6vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectHoraInicioEntrega"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              {horasDelDia.map((hora) => (
                                <MenuItem
                                  key={hora}
                                  value={hora}
                                  sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                >
                                  {hora}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>

                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectHoraFinEntrega${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                A:
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={horario.horaFin}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeEntrega(
                                  index,
                                  "horaFin",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "6vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectHoraFinEntrega"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              {horasDelDia.map((hora) => (
                                <MenuItem
                                  key={hora}
                                  value={hora}
                                  sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                >
                                  {hora}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>

                          {index > 0 && (
                            <IconButton
                              onClick={() => handleRemoveEntrega(index)}
                              sx={{ color: "red", marginTop: "1.4vw" }}
                            >
                              <RemoveIcon />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "0.5vw",
                        fontWeight: "bold"
                      }}
                    >
                      <IconButton
                        onClick={handleAddEntrega}
                        sx={{ color: "#006787" }}
                      >
                        Añadir horario
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Paper>

                  <Paper
                    elevation={3}
                    sx={{ p: 2, borderRadius: 4 }}
                    className="paperHorario"
                  >
                    {/* Lugar de atencion */}
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0vw" }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="h7"
                          fontWeight="bold"
                          gutterBottom
                          align="center"
                          sx={{
                            background:
                              "linear-gradient(90deg, #006787, #014e65)",
                            color: "white",
                            padding: "0.5vw 1vw",
                            borderRadius: "8px",
                            display: "inline-block",
                            marginTop: "0vw",
                            fontWeight: "bold"
                          }}
                        >
                          HORARIO DE ATENCION
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"2vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      {horariosAtencion.map((horario, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1vw",
                            paddingTop: "0.4vw",
                            flexWrap: "wrap",
                          }}
                        >
                          <Grid item xs={6}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`txfConceptoAtencion${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                {`Concepto #${index + 1}:`}
                              </InputLabel>
                            )}
                            <TextField
                              id={`txfConceptoAtencion${index}`}
                              fullWidth
                              disabled={viewOnly}
                              value={horario.concepto}
                              onChange={(e) =>
                                handleChangeAtencion(
                                  index,
                                  "concepto",
                                  e.target.value,
                                )
                              }
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "10vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfConceptoAtencion"
                            />
                          </Grid>

                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`txfDiaAtencion${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                Dia(s):
                              </InputLabel>
                            )}
                            <TextField
                              id={`txfDiaAtencion${index}`}
                              fullWidth
                              disabled={viewOnly}
                              value={horario.dias}
                              onChange={(e) =>
                                handleChangeAtencion(
                                  index,
                                  "dias",
                                  e.target.value,
                                )
                              }
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "8vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfDiaAtencion"
                            />
                          </Grid>

                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`txfHorarioAtencion${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                Horario:
                              </InputLabel>
                            )}
                            <TextField
                              id={`txfHorarioAtencion${index}`}
                              fullWidth
                              disabled={viewOnly}
                              value={horario.horario}
                              onChange={(e) =>
                                handleChangeAtencion(
                                  index,
                                  "horario",
                                  e.target.value,
                                )
                              }
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfHorarioAtencion"
                            />
                          </Grid>

                          {index > 0 && (
                            <IconButton
                              onClick={() => handleRemoveAtencion(index)}
                              sx={{ color: "red", marginTop: "1.4vw" }}
                            >
                              <RemoveIcon />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "0.5vw",
                        fontWeight: "bold"
                      }}
                    >
                      <IconButton
                        onClick={handleAddAtencion}
                        sx={{ color: "#006787" }}
                      >
                        Añadir horario
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Paper>
                </Stack>
                <Stack direction="row" spacing={"1vw"}>
                  <Paper
                    elevation={3}
                    sx={{ p: 2, borderRadius: 4 }}
                    className="paperHorario"
                  >
                    {/* Lugar de atencion */}
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0vw" }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="h7"
                          fontWeight="bold"
                          gutterBottom
                          align="center"
                          sx={{
                            background:
                              "linear-gradient(90deg, #006787, #014e65)",
                            color: "white",
                            padding: "0.5vw 1vw",
                            borderRadius: "8px",
                            display: "inline-block",
                            marginTop: "0vw",
                            fontWeight: "bold"
                          }}
                        >
                          ASIGNAR LISTAS DE PRECIO A SUCURSAL:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"2vw"}
                      sx={{ paddingTop: "0.8vw" }}
                    >
                      {listasPrecioSucursal.map((item, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "1vw",
                            paddingTop: "0.4vw",
                            flexWrap: "wrap",
                          }}
                        >
                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectListasPrecio${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                Lista de Precio:
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={item.idListaPrecio}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeListaPrecio(
                                  index,
                                  "idListaPrecio",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "10vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectListasPrecio"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              {listasPrecios.map((lista) => (
                                <MenuItem
                                  key={lista.idListaPrecio}
                                  value={lista.idListaPrecio}
                                  sx={{
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  }}
                                >
                                  {lista.nombre || "Lista de precio"}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectDiasPrecio${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                Dia(s):
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={item.dias}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeListaPrecio(
                                  index,
                                  "dias",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "8vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectDiasPrecio"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="LunesAviernes"
                              >
                                Lunes a Viernes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="SabadoDomingo"
                              >
                                Sabado y Domingo
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Lunes"
                              >
                                Lunes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Martes"
                              >
                                Martes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Miercoles"
                              >
                                Miercoles
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Jueves"
                              >
                                Jueves
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Viernes"
                              >
                                Viernes
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Sabados"
                              >
                                Sabados
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="Domingo"
                              >
                                Domingo
                              </MenuItem>
                            </Select>
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectHoraInicioPrecio${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                De:
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={item.horaInicio}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeListaPrecio(
                                  index,
                                  "horaInicio",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "6vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectHoraInicioPrecio"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              {horasDelDia.map((hora) => (
                                <MenuItem
                                  key={hora}
                                  value={hora}
                                  sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                >
                                  {hora}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>
                          <Grid item xs={2}>
                            {index === 0 && (
                              <InputLabel
                                htmlFor={`selectHoraFinPrecio${index}`}
                                sx={{
                                  color: "black",
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                }}
                              >
                                A:
                              </InputLabel>
                            )}
                            <Select
                              input={<OutlinedInput />}
                              value={item.horaFin}
                              disabled={viewOnly}
                              onChange={(e) =>
                                handleChangeListaPrecio(
                                  index,
                                  "horaFin",
                                  e.target.value,
                                )
                              }
                              sx={{
                                width: "6vw",
                                maxWidth: "100%",
                                height: "5vh",
                                minHeight: "0px !important",
                                overflow: "hidden",
                                "&.MuiInputBase-root": {
                                  minHeight: "0px !important",
                                },
                                "& .MuiSelect-select": {
                                  minHeight: "0px !important",
                                  padding: "0 0.5vw !important",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "1vw",
                                  lineHeight: "1",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  top: 0,
                                  "& legend": { display: "none" },
                                },
                                "& .MuiSvgIcon-root": {
                                  display: "inline-block !important",
                                  position: "absolute",
                                  right: "0.5vw",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  fontSize: "1.2vw !important",
                                  width: "1.2vw !important",
                                  height: "1.2vw !important",
                                  pointerEvents: "none",
                                },
                                minWidth: "0px !important",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="selectHoraFinPrecio"
                            >
                              <MenuItem
                                sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                value="seleccione"
                                disabled
                              >
                                Seleccione
                              </MenuItem>
                              {horasDelDia.map((hora) => (
                                <MenuItem
                                  key={hora}
                                  value={hora}
                                  sx={{ fontSize: "1vw", padding: "0.5vw" }}
                                >
                                  {hora}
                                </MenuItem>
                              ))}
                            </Select>
                          </Grid>

                          {index > 0 && (
                            <IconButton
                              onClick={() => handleRemoveListaPrecio(index)}
                              sx={{ color: "red", marginTop: "1.4vw" }}
                            >
                              <RemoveIcon />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "0.5vw",
                      }}
                    >
                      <IconButton
                        onClick={handleAddListaPrecio}
                        sx={{ color: "#006787" }}
                      >
                        Añadir lista
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Paper>

                  <Paper
                    elevation={3}
                    sx={{ p: 2, borderRadius: 4 }}
                    className="paperHorario"
                  >
                    {/* Lugar de atencion */}
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0vw" }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="h7"
                          fontWeight="bold"
                          gutterBottom
                          align="center"
                          sx={{
                            background:
                              "linear-gradient(90deg, #006787, #014e65)",
                            color: "white",
                            padding: "0.5vw 1vw",
                            borderRadius: "8px",
                            display: "inline-block",
                            marginTop: "0vw",
                            fontWeight: "bold"
                          }}
                        >
                          <PhoneIcon sx={{ fontSize: "1vw" }} />
                          TELEFONOS:
                        </Typography>
                      </Box>
                      {telefonos.map((telefono, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            paddingTop: "0.4vw",
                          }}
                        >
                          <InputLabel
                            htmlFor={`txfTelefono${index}`}
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                              width: "10vw",
                            }}
                          >
                            {index === 0 ? (
                              <>
                                {`Teléfono #${index + 1}: `}
                                <span style={{ color: "red" }}>*</span>
                              </>
                            ) : (
                              `Teléfono #${index + 1}:`
                            )}
                          </InputLabel>

                          <TextField
                            id={`txfTelefono${index}`}
                            value={telefono.telefono}
                            error={tieneMasDe10Digitos(telefono.telefono)}
                            helperText={tieneMasDe10Digitos(telefono.telefono) ? "Máximo 10 dígitos" : ""}
                            onChange={(e) =>
                              handleChangeTelefono(
                                index,
                                "telefono",
                                e.target.value,
                              )
                            }
                            fullWidth
                            disabled={viewOnly}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "12.5vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                          />
                          <Box sx={{ width: "3.1vw", textAlign: "center" }}>
                            {index > 0 && (
                              <IconButton
                                onClick={() => handleRemoveTelefono(index)}
                                sx={{ color: "red" }}
                              >
                                <RemoveIcon />
                              </IconButton>
                            )}
                          </Box>
                        </Box>
                      ))}
                    </Grid>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "0.5vw",
                      }}
                    >
                      <IconButton
                        onClick={handleAddTelefono}
                        sx={{ color: "#006787" }}
                      >
                        Añadir teléfono
                        <AddIcon />
                      </IconButton>
                    </Box>
                  </Paper>
                </Stack>
              </Stack>
              <Paper
                elevation={3}
                sx={{ p: 2, borderRadius: 4, marginTop: "2vh" }}
                className="paperDoc"
              >
                <Typography
                  variant="h7"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    display: "inline-block",
                    fontWeight: "bold"
                  }}
                >
                  DEPARTAMENTOS DE LA SUCURSAL:
                </Typography>

                <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  {" "}
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
                        Nombre
                      </TableCell>
                      <TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
                        Codigo
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sucursalesActivos.length > 0 ? (
                      sucursalesActivos.map((departamento, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <TextField
                                value={departamento.nombre}
                                onChange={(e) =>
                                  handleChangeDepartamento(
                                    index,
                                    "nombre",
                                    e.target.value,
                                  )
                                }
                                disabled={viewOnly}
                                sx={{
                                  width: "18vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <TextField
                                value={departamento.codigo}
                                onChange={(e) =>
                                  handleChangeDepartamento(
                                    index,
                                    "codigo",
                                    e.target.value,
                                  )
                                }
                                disabled={viewOnly}
                                sx={{
                                  width: "18vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                    padding: "0.5vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center" sx={{ py: 4 }}>
                          No hay registros
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "0.5vw",
                  }}
                >
                  <IconButton
                    onClick={handleAddDepartamento}
                    sx={{ color: "#006787" }}
                  >
                    Añadir departamento
                    <AddIcon />
                  </IconButton>
                </Box>
              </Paper>
            </TabPanel>
          </Box>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar sucursal"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                onClick={editarSucursal}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <SaveIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip
            title={"Buscar sucursal"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={handleBuscarSucursal}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default EditarSucursal;
